"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.selectionStore = exports.STATE_KEY = exports.DATA_KEY = void 0;
/* eslint-disable */
/* TODO: fix ALL linting errors as some may call out code smells */
const immer_1 = __importStar(require("immer"));
const zustand_1 = require("zustand");
const middleware_1 = require("zustand/middleware");
const selection_utils_1 = require("./selection.utils");
// we need access to the product data when updating the state, I stored the data in the store as well for ease of use
// we could get the product data from another context if we wanted, do we want to get the product data from the store as well,
// we dont have to worry about rerenders i dont think
const DATA_KEY = 'productData';
exports.DATA_KEY = DATA_KEY;
const STATE_KEY = 'productState';
exports.STATE_KEY = STATE_KEY;
const environment = process.env.NEXT_PUBLIC_APP_ENV || 'production';
/**
 * Saves all products and the matching variants as objects for easy look up
 * @param {*} state
 * @param {import('./selection.types').Product[]} productsData
 * @param {import('./selection.types').AttributeValue} pageDefinedAttributes
 * @param {import('./selection.types').AttributeValue} userDefinedAttributes
 * @param {import('./selection.types').AttributeValue} productOverrides
 * @param {boolean} defaultInStock
 * @returns {{
 *  productsData: Object.<string, import('./selection.types').Product>,
 *  productState: Object.<string, import('./selection.types').Variant>
 * }}
 */
const _initializeStore = (state, productsData, pageDefinedAttributes, userDefinedAttributes, productOverrides, defaultInStock) => {
    const transformedProductsData = (0, selection_utils_1.transformCatalogProducts)(productsData);
    const initialState = (0, selection_utils_1.getInitialState)(transformedProductsData, pageDefinedAttributes, userDefinedAttributes, productOverrides, defaultInStock);
    return {
        [DATA_KEY]: {
            ...state[DATA_KEY],
            ...transformedProductsData
        },
        [STATE_KEY]: {
            ...state[STATE_KEY],
            ...initialState
        }
    };
};
/**
     * Helper function to update a single product's attributes
     * @param {*} state - Current state to modify
     * @param {*} originalState - Original immutable state
     * @param {string} productCode
     * @param {import('./selection.types').AttributeValue} updatedAttributes
     * @returns {void}
     */
const _updateSingleProduct = (state, originalState, productCode, updatedAttributes) => {
    const currentProductState = originalState[STATE_KEY][productCode];
    const productData = originalState[DATA_KEY][productCode];
    const variants = productData.variants;
    const configurableAttributes = productData.configurableAttributes;
    // if we dont have a current state and current variants then we cannot update this product
    if (!currentProductState || !productData) {
        console.log('cannot update because we dont have product state and data');
        return;
    }
    // merge current state with the updated attributes
    const newProductAttributes = (0, selection_utils_1.mergeProductAttributes)(currentProductState, updatedAttributes);
    // find product variant that matches new state
    const newProductVariant = (0, selection_utils_1.findMatchingVariant)(variants, newProductAttributes, configurableAttributes);
    if (!newProductVariant) {
        console.log('unable to find single product variant that matches new state');
        return;
    }
    // update the state with the new variant attributes
    const quantity = updatedAttributes.quantity === 0 ? 0 : updatedAttributes.quantity || currentProductState.quantity;
    state[STATE_KEY][productCode] = (0, selection_utils_1.getStateFromVariant)(newProductVariant, quantity);
};
const createSelectionSlice = (set) => ({
    [DATA_KEY]: {},
    [STATE_KEY]: {},
    /**
     * @param {import('./selection.types.js').Product[]} productsData
     * @param {import('./selection.types.js').AttributeValue} pageDefinedAttributes
     * @param {import('./selection.types.js').AttributeValue} userDefinedAttributes
     * @param {import('./selection.types.js').AttributeValue} productOverrides
     * @param {boolean} defaultInStock
     * @returns
     */
    initializeStore: (productsData, pageDefinedAttributes, userDefinedAttributes, productOverrides, defaultInStock) => set((state) => {
        return _initializeStore(state, productsData, pageDefinedAttributes, userDefinedAttributes, productOverrides, defaultInStock);
    }, false, {
        type: 'selection/initializeStore',
        productsData,
        pageDefinedAttributes,
        userDefinedAttributes,
        productOverrides
    }),
    /**
     * Update multiple products' attributes in a single state update
     * @param {Object.<string, import('./selection.types').AttributeValue>} updates - Object with product codes as keys and their attribute updates as values
     * @returns {void}
     */
    batchUpdateProductAttributes: (updates) => set((0, immer_1.default)((state) => {
        const originalState = (0, immer_1.original)(state);
        Object.entries(updates).forEach(([productCode, updatedAttributes]) => {
            _updateSingleProduct(state, originalState, productCode, updatedAttributes);
        });
    }), false, {
        type: 'selection/batchUpdateProductAttributes',
        updates
    }),
    /**
     * Update the currently selected variant according to the attributes selected by the user (size, swatch)
     * @param {string} productCode
     * @param {import('./selection.types').AttributeValue} updatedAttributes
     * @returns {void}
     */
    updateProductAttributes: (productCode, updatedAttributes) => set((0, immer_1.default)((state) => {
        const originalState = (0, immer_1.original)(state);
        _updateSingleProduct(state, originalState, productCode, updatedAttributes);
    }), false, {
        type: 'selection/updateProductAttributes',
        productCode,
        updatedAttributes
    })
});
const slices = (...a) => ({
    ...createSelectionSlice(...a)
});
const selectionStore = (0, zustand_1.createStore)((0, middleware_1.devtools)(slices, { name: 'SelectionStore', enabled: environment !== 'production', maxAge: 25 }));
exports.selectionStore = selectionStore;
//# sourceMappingURL=selection.store.js.map